'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import SearchStatusPropType from 'SalesContentIndexUI/propTypes/SearchStatusPropType';
import SearchQueryRecord from 'SalesContentIndexUI/data/records/SearchQueryRecord';
import SearchStatus from 'SalesContentIndexUI/data/constants/SearchStatus';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { jsx as _jsx } from "react/jsx-runtime";
export default class IndexTablePaginator extends Component {
  constructor(...args) {
    super(...args);
    this.handlePageChange = ({
      target
    }) => {
      const page = target.value - 1;
      this.props.getPage(page);
    };
  }
  render() {
    const {
      searchQuery,
      totalPages,
      searchStatus
    } = this.props;
    if (totalPages <= 1 || searchStatus === SearchStatus.LOADING) {
      return null;
    }
    return /*#__PURE__*/_jsx(Paginator, {
      onPageChange: this.handlePageChange,
      page: searchQuery.getCurrentPage(),
      pageCount: totalPages,
      showFirstLastButtons: totalPages > 5
    });
  }
}
IndexTablePaginator.propTypes = {
  searchQuery: PropTypes.instanceOf(SearchQueryRecord).isRequired,
  totalPages: PropTypes.number.isRequired,
  searchStatus: SearchStatusPropType.isRequired,
  getPage: PropTypes.func.isRequired
};